import { render, staticRenderFns } from "./BlockEmbeddedVideo.vue?vue&type=template&id=ecd275b2&scoped=true"
import script from "./BlockEmbeddedVideo.vue?vue&type=script&lang=js"
export * from "./BlockEmbeddedVideo.vue?vue&type=script&lang=js"
import style0 from "./BlockEmbeddedVideo.vue?vue&type=style&index=0&id=ecd275b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd275b2",
  null
  
)

export default component.exports